export const CloserStatsScreenPath =
  "/closers/check-closers-availability/stats";
